import { capitalize } from "../string/capitalize";

export const keyWithType = <T>(key: string, prefix = "", postfix = "") => {
  const formattedKey = prefix.length ? capitalize(key) : key;
  return `${prefix}${formattedKey}${postfix}` as T;
};
